/*
Make a drawer webcomponent

HTML Usage (Example):

<drawer-element data-toggle-class="filter-is-open">
  <div data-draggable-drawer>
  <toggle-element-class data-close-drawer>
    <button data-mobile-drag-bar>
    </button>
  </toggle-element-class>  
</drawer-element>
*/

if (!customElements.get('drawer-element')) {
  class DrawerElement extends HTMLElement {
    constructor() {
      super();

      // get drag event to close drawer and show/hide top shadow according to the visibility of the fieldset legend - Options & Upsell products drawers / mobile only, when the browser supports touch
      if (!!('ontouchstart' in document)) {
        this.querySelectorAll('[data-mobile-drag-bar]').forEach((dragBar) => {
          // Add the drag to close functionality
          dragBar.draggable = 'true';
          dragBar.addEventListener('touchstart', this.handleDrawerDragToClose);
          dragBar.addEventListener('mousedown', this.handleDrawerDragToClose);

          // Update the top shadow visibility
          // TODO: Find a way to only call this when the drawer is open
          //this.updateTopShadowVisibility(dragBar);
        });
      }

      this.querySelectorAll('[data-mobile-drag-bar]').forEach((dragBar) => {
        // Add the drag to close functionality
        dragBar.draggable = 'true';
        dragBar.addEventListener('touchstart', this.handleDrawerDragToClose);
        dragBar.addEventListener('mousedown', this.handleDrawerDragToClose);
      });
    }

    /**
     * handleDrawerDragToClose
     * @description Handle drawer drag down to close it on mobile. Options & Upsell products drawers / mobile only, when the browser supports touch
     */
    handleDrawerDragToClose(event) {
      const drawer = event.target.closest('[data-draggable-drawer]'),
        toggleClass = event.target.closest('drawer-element').dataset.toggleClass;

      // get the classes to open and close the drawer
      const body = document.querySelector('body');

      // Global variables for tracking drag events - Sets initial drag position, drawer height and sets transition to none for the drawer on dragging
      let isDragging = true;
      let startY = event.touches?.[0].clientY || event.clientY;
      const startHeight = drawer.offsetHeight;
      body.classList.add('drawer-dragging');

      // Calculates the new height for the drawer and calls the updateDrawerHeight function
      const dragging = (event) => {
        if (!isDragging) return;
        const difference = startY - (event.touches?.[0].clientY || event.clientY);
        const newHeight = startHeight + (difference / window.innerHeight) * 100;
        updateDrawerHeight(newHeight);
      };

      // Determines whether to hide or set the height to default
      const dragStop = () => {
        isDragging = false;
        body.classList.remove('drawer-dragging');
        const drawerHeight = drawer.offsetHeight;
        drawerHeight < startHeight - 10 ? hideDrawer() : updateDrawerHeight(startHeight);

        // remove event listeners
        document.removeEventListener('mousemove', dragging);
        document.removeEventListener('mouseup', dragStop);
        document.removeEventListener('touchmove', dragging);
        document.removeEventListener('touchend', dragStop);
      };

      // updates the height of the drawer
      const updateDrawerHeight = (height) => (drawer.style.height = `${Math.floor(height)}px`);

      // Hide the drawer by removing the toggle element classes from the body
      const hideDrawer = () => {
        drawer.querySelector('[data-close-drawer]')?.click();
        body.classList.remove(toggleClass);
        body.classList.remove('header-is-active');
        updateDrawerHeight(startHeight);
      };

      // add event listeners on drag (touch and mouse events)
      document.addEventListener('touchmove', dragging);
      document.addEventListener('touchend', dragStop);
      document.addEventListener('mousemove', dragging);
      document.addEventListener('mouseup', dragStop);
    }
  }

  window.DrawerElement = DrawerElement;

  customElements.define('drawer-element', DrawerElement);
}
